import { Menu } from "@mantine/core";
import { DateTime } from "luxon";
import type { MRT_ColumnDef } from "mantine-react-table-open";
import { MantineActionCell } from "../../../../../mantine/mrt/components/cell/MantineActionCell/MantineActionCell";
import { backendDateOrDateTimeToLuxonDateTime } from "../../../../../utils/dates/backendDateOrDateTimeToLuxonDateTime";
import { MONTH_YEAR_FORMAT } from "../../../../../utils/dates/dates.constants";
import { sortBackendDates } from "../../../../../utils/dates/sortBackendDates";
import type { EnergyRevenuesListItem } from "../../../RevenueMonitoring.types";
import { REVENUE_TABLE_HEADER_TEXTS } from "../EnergyRevenuesTable";

export function getPeriodStartColumn(
  handleBatchCreateVerification: (row: EnergyRevenuesListItem) => Promise<void>,
  hasDataVerificationColumns: boolean
): MRT_ColumnDef<EnergyRevenuesListItem> {
  return {
    id: "period_start",
    header: REVENUE_TABLE_HEADER_TEXTS["period_start"],
    enableHiding: false,
    accessorFn: (row) =>
      backendDateOrDateTimeToLuxonDateTime(row.period_start).toLocaleString(
        MONTH_YEAR_FORMAT
      ),
    Cell: ({ cell, row }) => {
      if (!hasDataVerificationColumns) {
        return <>{cell.getValue<string>()}</>;
      }
      return (
        <MantineActionCell
          iconTitle={`Aktionen für Monat ${cell.getValue<string>()}`}
          menuDropdown={
            <Menu.Dropdown p={0}>
              <Menu.Item
                onClick={() => {
                  handleBatchCreateVerification(row.original);
                }}
              >
                Alle Werte dieses Monats prüfen
              </Menu.Item>
            </Menu.Dropdown>
          }
        >
          {cell.getValue<string>()}
        </MantineActionCell>
      );
    },
    filterVariant: "multi-select",
    sortingFn: (rowA, rowB) =>
      sortBackendDates(rowA.original.period_start, rowB.original.period_start),
    mantineFilterMultiSelectProps: ({ column }) => ({
      data: Array.from(column.getFacetedUniqueValues().keys()).sort((a, b) => {
        return (
          DateTime.fromFormat(a, "MMM yyyy").toJSDate().getTime() -
          DateTime.fromFormat(b, "MMM yyyy").toJSDate().getTime()
        );
      })
    }),
    footer: "Summe",
    mantineTableFooterCellProps: {
      style: {
        verticalAlign: "middle"
      }
    },
    size: 240,
    minSize: 100
  };
}
